import { render } from "./ColumnSkeleton.vue?vue&type=template&id=7c2e6187"
import script from "./ColumnSkeleton.vue?vue&type=script&lang=js"
export * from "./ColumnSkeleton.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "../less/columnSkeleton.less?vue&type=style&index=0&lang=less&module=true&external"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__